export default "__VITE_ASSET__8f4e7b96__"